(function () {
  var mobile = window.matchMedia('(max-width: 899px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function groups() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-sp-group]'));
  }

  /* ---------- Sticky theme header detection ----------
     Finds the theme's sticky/fixed header (and sticky announcement bar),
     so section titles never end up hidden behind it. Works with headers
     that are always sticky and with headers that hide/reveal on scroll. */
  var headerEls = [];

  function findHeaders() {
    headerEls = [];
    var nodes = document.querySelectorAll('body > *, body > * > *, body > * > * > *');
    nodes.forEach(function (el) {
      if (el.closest('.sp') || el.querySelector('.sp-toc')) return;
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      if (cs.top === 'auto' || cs.display === 'none' || cs.visibility === 'hidden') return;
      if (parseFloat(cs.top) > 1) return;
      if (el.offsetHeight === 0 || el.offsetHeight > 300) return;
      if (el.offsetWidth < window.innerWidth * 0.5) return;
      headerEls.push(el);
    });
  }

  function settingOffset() {
    var nav = document.querySelector('[data-sp-toc]');
    return nav ? parseFloat(nav.getAttribute('data-sticky-offset')) || 0 : 0;
  }

  // Full header height: the space a section title needs after a jump.
  function headerFullHeight() {
    var h = 0;
    headerEls.forEach(function (el) {
      if (!document.body.contains(el)) return;
      var cs = getComputedStyle(el);
      if (cs.position === 'fixed' || cs.position === 'sticky') h = Math.max(h, el.offsetHeight);
    });
    return Math.max(h, settingOffset());
  }

  // Part of the header visible right now: keeps the menu tucked under it.
  function headerVisibleBottom() {
    var b = 0;
    headerEls.forEach(function (el) {
      if (!document.body.contains(el)) return;
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.top <= 1) b = Math.max(b, r.bottom);
    });
    return Math.max(0, Math.round(b), settingOffset());
  }

  function updateSticky() {
    document.documentElement.style.setProperty('--sp-sticky', headerVisibleBottom() + 'px');
  }

  /* ---------- Menu ---------- */
  function setActive(id) {
    var nav = document.querySelector('[data-sp-toc]');
    if (!nav) return;
    nav.querySelectorAll('[data-sp-link]').forEach(function (link) {
      var on = link.getAttribute('data-sp-link') === id;
      link.classList.toggle('is-active', on);
      if (on) {
        link.setAttribute('aria-current', 'true');
        if (mobile.matches) nav.scrollTo({ left: link.offsetLeft - 16, behavior: 'smooth' });
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  // Builds the menu from the policy sections on the page,
  // so adding, renaming or reordering sections updates it automatically.
  function buildMenu() {
    var list = document.querySelector('[data-sp-toc-links]');
    if (!list) return;
    list.innerHTML = '';
    groups().forEach(function (g) {
      var label = g.getAttribute('data-sp-label');
      if (!label || !g.id) return;
      var a = document.createElement('a');
      a.href = '#' + g.id;
      a.setAttribute('data-sp-link', g.id);
      a.textContent = label;
      list.appendChild(a);
    });
  }

  /* ---------- Scrolling to a section ---------- */
  function scrollToGroup(group, smooth) {
    var nav = document.querySelector('[data-sp-toc]');
    var gap = 24;
    if (mobile.matches && nav) gap = nav.offsetHeight + 16; // room for the pill bar
    var y = window.scrollY + group.getBoundingClientRect().top - headerFullHeight() - gap;
    window.scrollTo({ top: Math.max(0, y), behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto' });
  }

  /* ---------- Scroll spy ----------
     The active item is the last visible section whose top has passed a line
     just below the header. After a click, the clicked item stays highlighted. */
  var clickedId = null;
  var releaseTimer = null;
  var ticking = false;
  var listening = false;

  function computeActive() {
    var visible = groups().filter(function (g) { return g.style.display !== 'none'; });
    if (!visible.length) return;
    var nav = document.querySelector('[data-sp-toc]');
    var line = headerFullHeight() + (mobile.matches && nav ? nav.offsetHeight + 40 : 40);
    var active = visible[0].id;
    visible.forEach(function (g) {
      if (g.getBoundingClientRect().top - line <= 0) active = g.id;
    });
    if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
      active = visible[visible.length - 1].id;
    }
    setActive(active);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      updateSticky();
      if (clickedId) {
        clearTimeout(releaseTimer);
        releaseTimer = setTimeout(function () { clickedId = null; }, 150);
      } else {
        computeActive();
      }
    });
  }

  function initScrollSpy() {
    findHeaders();
    updateSticky();
    computeActive();
    if (listening) return;
    listening = true;

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { findHeaders(); onScroll(); });
    // Headers that slide in/out on scroll: re-measure when their animation ends
    document.addEventListener('transitionend', function () { updateSticky(); }, true);

    // Menu items and quick-link cards that point to a policy section
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href^="#"]');
      if (!link) return;
      var id = decodeURIComponent(link.getAttribute('href').slice(1));
      var group = id && document.getElementById(id);
      if (!group || !group.hasAttribute('data-sp-group')) return;
      e.preventDefault();
      if (group.style.display === 'none') return;
      clickedId = id;
      setActive(id);
      clearTimeout(releaseTimer);
      releaseTimer = setTimeout(function () { clickedId = null; }, 1000);
      scrollToGroup(group, true);
      history.replaceState(null, '', '#' + id);
    });
  }

  var hashHandled = false;

  function init() {
    buildMenu();
    initScrollSpy();
    if (hashHandled) return;
    hashHandled = true;
    // Arriving from a link such as /pages/terms-and-policies#returns
    var id = location.hash ? decodeURIComponent(location.hash.slice(1)) : '';
    var group = id && document.getElementById(id);
    if (group && group.hasAttribute('data-sp-group')) {
      clickedId = id;
      setActive(id);
      setTimeout(function () { scrollToGroup(group, false); }, 50);
    }
  }

  /* ---------- Search ---------- */
  // Hide menu items whose section has no results; highlight the first one left.
  function syncMenu() {
    var firstVisible = null;
    document.querySelectorAll('[data-sp-link]').forEach(function (link) {
      var group = document.getElementById(link.getAttribute('data-sp-link'));
      var hidden = !group || group.style.display === 'none';
      link.style.display = hidden ? 'none' : '';
      if (!hidden && !firstVisible) firstVisible = group.id;
    });
    if (firstVisible) setActive(firstVisible);
  }

  function runSearch(input) {
    var count = document.querySelector('[data-sp-count]');
    var raw = input.value.trim();
    var q = raw.toLowerCase();
    var blocks = document.querySelectorAll('[data-sp-block]');

    if (!q) {
      blocks.forEach(function (b) { b.style.display = ''; });
      groups().forEach(function (g) { g.style.display = ''; });
      syncMenu();
      if (count) count.textContent = '';
      return;
    }

    var hits = 0;
    blocks.forEach(function (b) {
      var match = b.textContent.toLowerCase().indexOf(q) !== -1;
      b.style.display = match ? '' : 'none';
      if (match) hits++;
    });
    groups().forEach(function (g) {
      var shown = Array.prototype.some.call(g.querySelectorAll('[data-sp-block]'), function (b) {
        return b.style.display !== 'none';
      });
      g.style.display = shown ? '' : 'none';
    });
    syncMenu();

    if (count) {
      var one = input.getAttribute('data-result-one') || '[count] result for “[query]”';
      var many = input.getAttribute('data-result-many') || '[count] results for “[query]”';
      var none = input.getAttribute('data-result-none') || 'No results for “[query]”';
      var text = hits ? (hits === 1 ? one : many) : none;
      count.textContent = text.replace('[count]', hits).replace('[query]', raw);
    }
  }

  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-sp-search]')) runSearch(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Keep the menu in sync while editing in the theme editor
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(init, 50); });
  });
})();